import Vue from 'vue'

const useResize = () => {
  const breakpoints = Vue.observable({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    size: null,
  })

  const checkBreakpoints = () => {
    const windowSize = window.innerWidth
    breakpoints.size = windowSize
    if (windowSize < 768) {
      breakpoints.isMobile = true
    } else breakpoints.isMobile = false

    if (windowSize < 1024 && !breakpoints.isMobile) {
      breakpoints.isTablet = true
    } else {
      breakpoints.isTablet = false
    }

    if (windowSize >= 1024) {
      breakpoints.isDesktop = true
    } else breakpoints.isDesktop = false
  }

  checkBreakpoints()

  window.addEventListener('resize', checkBreakpoints)

  return breakpoints
}
export { useResize }
